import React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@mebi/ui'

const spinnerVariants = cva(
  "animate-spin rounded-full border-2 border-solid border-current border-r-transparent",
  {
    variants: {
      size: {
        sm: "h-4 w-4",
        md: "h-6 w-6", 
        lg: "h-8 w-8",
      },
      variant: {
        primary: "text-mebi-yellow-500",
        white: "text-white",
        neutral: "text-neutral-600",
        inherit: "text-inherit",
      },
    },
    defaultVariants: {
      size: "md",
      variant: "primary",
    },
  },
)

export interface SpinnerProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof spinnerVariants> {}

const Spinner = React.forwardRef<HTMLDivElement, SpinnerProps>(
  ({ className, size, variant, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(spinnerVariants({ size, variant }), className)}
        {...props}
      />
    )
  },
)
Spinner.displayName = "Spinner"

export { Spinner }